module.exports = __webpack_public_path__ + "static/media/boxing-glove.ee47afd5.svg";